<template>
  <div>
    <div class="suspension flex" @click="show = true">
      <i class="el-icon-caret-left"></i>
    </div>
    <el-drawer
        :show-close="false" :close-on-press-escape="false" :modal="false"
        :visible.sync="show" class="suspensionDrawer" :wrapperClosable="false" :modal-append-to-body="false"
        :with-header="false" size="150px">
      <div class="shrink flex" @click="show=false"><i class="el-icon-caret-right"></i></div>
      <div class="suspensionList">
        <template v-if="userType==='doctor'">
          <span class="tit" @click="$router.push('/doctor/doctorHelp')">帮助中心</span>
        </template>
        <template v-else>
          <span class="tit" @click="$router.push('/user/counsel')">我的预约</span>
          <span class="tit" @click="$router.push('/user/physician')">我的医生</span>
          <span class="tit" @click="$router.push('/user/psyTest')">我的测试</span>
          <span class="tit" @click="$router.push('/user/mineCoupon')">我的优惠券</span>
          <span class="tit" @click="$router.push('/helpCenter')">帮助中心</span>
        </template>
        <el-popover class="item" trigger="hover" placement="left">
          <span slot="reference">公众号</span>
          <img src="../assets/img/official.jpg" alt="" width="258">
        </el-popover>
        <el-popover class="item" trigger="hover" placement="left">
          <span slot="reference">移动端</span>
          <img src="../assets/img/phone.png" alt="" width="258">
        </el-popover>
        <el-popover class="item" trigger="hover" placement="left">
          <span slot="reference">微信小程序</span>
          <img src="../assets/img/ys_chat.jpg" alt="" width="258">
        </el-popover>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "suspensionDrawer",
  data() {
    return {
      userType: '',
      show: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.show = false
    }, 30000)

    if (localStorage.user_type && localStorage.user_type == 2) {
      this.userType = 'doctor';
    } else if (localStorage.user_type == 1) {
      this.userType = 'user';
    }
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
//悬浮
.suspensionDrawer.el-drawer__wrapper ::v-deep {
  right: 0;
  top: 25%;
  width: 150px;
  left: auto;
  height: 340px;
  bottom: auto;

  .shrink {
    font-size: 30px;
    color: #567BFF;
    cursor: pointer;
    width: 31px;
    height: 30px;
    background: #ffffff;
  }

  .el-drawer {
    background: transparent;
    box-shadow: none;
  }

  .el-drawer__body {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .el-popover__reference {
    width: 100%;
    display: inline-block;
  }
}

.suspension {
  background: #ffffff;
  box-shadow: 0 0 21px 0 rgba(121, 149, 248, 0.5);
  z-index: 20;
  position: fixed;
  height: 50px;
  cursor: pointer;
  right: 0;
  top: 40%;
  font-size: 40px;
  color: #567BFF;
}

.suspensionList {
  background: #ffffff;
  color: #303139;
  z-index: 12;
  display: flex;
  flex-flow: column;
  justify-content: center;
  box-shadow: 0 0 21px 0 rgba(121, 149, 248, 0.5);
  font-size: 13px;
  position: relative;

  span.item, span.tit {
    line-height: 40px;
    cursor: pointer;
    width: 119px;
    text-align: center;

    ::v-deep .el-popover__reference {
      width: 119px;
      height: 40px;
      display: inline-block;
      outline: none;
    }

    &:hover {
      background-color: #567BFF;
      color: #ffffff;
    }
  }
}

</style>
